export default {
  title: 'MBD Team Detail Report',
  timeSpentByAttorneyTitle: 'Time spent by Attorney',
  attorneysFilterLabel: 'Filter by attorney',
  export: 'Export',
};
